/**
 * Andre Garen - Anasayfa "story highlight" kategori seridi.
 * (Karar 2, Yigit onayi: akordiyon/cekmece yerine gelen serit.)
 *
 * SADECE anasayfada calisir - hem Gunduz hem Abiye dunyasi ayni DOM'da
 * bulundugu icin (ag-two-worlds.liquid, CSS ile mod'a gore gosterilir/
 * gizlenir) burada sayfa yenilemeden mod degistirmek ve urun akisini
 * filtrelemek guvenli. Diger sayfalarda bu betik hic yuklenmez (bkz.
 * layout/theme.liquid, template.name == 'index' kosulu) - oralarda
 * .ag-highlight <a>'lari ve GUNLUK/ABIYE sekmeleri normal baglanti
 * olarak calismaya devam eder, hicbir sey bozulmaz.
 *
 * COKLU SECIM: bir highlight'a dokunmak onu aktif kumeye ekler/cikarir
 * (tekli secim DEGIL). Kume bossa o sekmenin TUM urunleri gosterilir.
 *
 * Denetim (pre-launch audit, P0 - Takim/Keten/Midi Boy 4 urunden 3'unu
 * sifirliyordu): eslestirme eskiden TAM esitlikti (tags.indexOf(t) > -1,
 * yani urun etiketi harfi harfine "keten" olmali). Gercek katalogda etiketler
 * cogunlukla BILESIK ("keten elbise", "gunluk elbise", "maksi elbise" - tek
 * bir etiket string'i, "keten"+"elbise" ayri degil), bu yuzden rozet
 * etiketiyle (kisa/atomik) TAM eslesme cok az urunde tutuyordu. Artik ALT
 * DIZE eslestirme yapiliyor (rozet etiketi urunun herhangi bir etiketinin
 * ICINDE geciyorsa eslesir) - "keten" artik "keten elbise" icinde de
 * buluyor. Bu, Elbise/Keten/Midi icin gercek veriyle dogrulandi (canli:
 * Elbise 4/4, Midi 1/4, Keten 1/4 - tutarli). Takim rozeti anasayfadaki
 * ilk 4 "gunluk" urununde HALA 0 sonuc verebilir - bunun nedeni eslestirme
 * degil, o an yuklenen 4 urunun hicbirinin gercekten Takim tipinde
 * OLMAMASI (icerik/kurasyon meselesi, kod tarafinda duzeltilemez). Bu
 * yuzden asagida 0 sonuc durumu icin ayrica bir bos-durum mesaji + temizle
 * dugmesi eklendi (audit'in ayrica belirttigi "0 sonuçta sessiz kalma"
 * sorununu da cozuyor) - boylece "Takim"a dokunup hicbir sey gormemek
 * yerine musteri neden bos oldugunu goruyor ve tek dokunuşla geri donebiliyor.
 */
(function () {
  'use strict';

  var worlds = document.querySelector('[data-ag-worlds]');
  if (!worlds) return;

  var active = { day: new Set(), night: new Set() };

  function cardsFor(mode) {
    var world = worlds.querySelector('.ag-world[data-ag-world="' + mode + '"]');
    if (!world) return [];
    return Array.prototype.slice.call(world.querySelectorAll('[data-ag-tags]'));
  }

  function feedContainerFor(mode) {
    var world = worlds.querySelector('.ag-world[data-ag-world="' + mode + '"]');
    if (!world) return null;
    return world.querySelector('.ag-grid, .ag-rail');
  }

  function emptyStateFor(mode) {
    var container = feedContainerFor(mode);
    if (!container) return null;
    var msg = worlds.querySelector('[data-ag-hlempty="' + mode + '"]');
    if (!msg) {
      msg = document.createElement('div');
      msg.setAttribute('data-ag-hlempty', mode);
      msg.className = 'ag-hlempty ag-pad';
      msg.hidden = true;
      msg.innerHTML =
        '<p class="ag-body-text">Bu seçimde ürün yok.</p>' +
        '<button type="button" class="ag-hlempty__clear">Filtreyi temizle</button>';
      container.insertAdjacentElement('afterend', msg);
    }
    return msg;
  }

  function clearMode(mode) {
    active[mode].clear();
    var rail = document.querySelector('[data-ag-hlrail="' + mode + '"]');
    if (rail) {
      rail.querySelectorAll('.ag-highlight[aria-pressed="true"]').forEach(function (el) {
        el.setAttribute('aria-pressed', 'false');
      });
    }
    applyFilter(mode);
  }

  function applyFilter(mode) {
    var set = active[mode];
    var visible = 0;
    cardsFor(mode).forEach(function (card) {
      if (set.size === 0) { card.hidden = false; visible++; return; }
      var tags = (card.getAttribute('data-ag-tags') || '').toLowerCase().split('|');
      var match = false;
      set.forEach(function (t) {
        if (tags.some(function (ct) { return ct.indexOf(t) > -1; })) match = true;
      });
      card.hidden = !match;
      if (match) visible++;
    });

    var container = feedContainerFor(mode);
    var showEmpty = set.size > 0 && visible === 0;
    if (container) container.hidden = showEmpty;
    var msg = emptyStateFor(mode);
    if (msg) msg.hidden = !showEmpty;
  }

  /* ---- highlight tiklamasi: coklu-secim toggle + filtre ---- */
  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest && e.target.closest('.ag-hlempty__clear');
    if (clearBtn) {
      var msgEl = clearBtn.closest('[data-ag-hlempty]');
      var clearMode_ = msgEl && msgEl.getAttribute('data-ag-hlempty');
      if (clearMode_ === 'day' || clearMode_ === 'night') clearMode(clearMode_);
      return;
    }

    var el = e.target.closest && e.target.closest('.ag-highlight[data-ag-hl-tag]');
    if (!el) return;
    var tag = el.getAttribute('data-ag-hl-tag');
    if (!tag) return;
    var rail = el.closest('[data-ag-hlrail]');
    var mode = rail && rail.getAttribute('data-ag-hlrail');
    if (mode !== 'day' && mode !== 'night') return;

    e.preventDefault();
    tag = tag.toLowerCase();
    var set = active[mode];
    var pressed = el.getAttribute('aria-pressed') === 'true';
    if (pressed) {
      set.delete(tag);
      el.setAttribute('aria-pressed', 'false');
    } else {
      set.add(tag);
      el.setAttribute('aria-pressed', 'true');
    }
    applyFilter(mode);
  });

  /* ---- GUNLUK/ABIYE sekmeleri: anasayfada sayfa gecisine gerek yok -----
     Iki dunya da DOM'da hazir oldugu icin sadece modu degistirip ayni
     sayfada kalmak yeterli. ag-mode.js'deki genel tiklama dinleyicisi
     (P0 duzeltmesi sonrasi) navigasyonu ENGELLEMEDEN setMode() cagirmaya
     devam ediyor - burada SADECE preventDefault ekliyoruz, mod degisimi
     halihazirda calisan o mekanizmadan geliyor (kod tekrari yok). */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ag-mode-tab]');
    if (!tab || tab.hasAttribute('data-ag-kapanis-git')) return;
    e.preventDefault();
  });
})();
